;(function () {
  angular
    .module('contrast.wizard')
    .directive('wizardFooter', function ($timeout, $window) {
      'ngInject'

      return {
        restrict: 'C',
        scope: true,
        link: function (scope, element) {
          $window.addEventListener('scroll', onScroll)
          $window.addEventListener('resize', onResize)

          var wizardScroll = element.parent().parent()
          var wizardScroller = element.parent().parent().parent()
          var body = wizardScroll.find('.wizard-body')

          scope.$watch(
            function () {
              return wizardScroller[0].offsetHeight
            },
            function (newValue, oldValue) {
              if (newValue != oldValue) {
                setFooterPostion()
              }
            }
          )

          scope.$watch(
            function () {
              return body[0].offsetHeight
            },
            function (newValue, oldValue) {
              if (newValue != oldValue) {
                setFooterPostion()
              }
            }
          )

          scope.$watch(
            function () {
              return wizardScroll.css('display')
            },
            function (newValue, oldValue) {
              if (newValue != oldValue) {
                $timeout(function () {
                  setFooterPostion()
                })
              }
            }
          )

          function isBottomTouching() {
            var rect = wizardScroller[0].getBoundingClientRect(),
              bottom = rect.bottom,
              windowHeight = $window.innerHeight

            //some leeway
            bottom += 2

            return bottom > windowHeight
          }

          function setFooterPostion() {
            if (wizardScroll.css('display') != 'none') {
              if (isBottomTouching()) {
                element.css('position', 'absolute')
                element.css('width', '100%')
                body.css('margin-bottom', '48px')
              } else {
                element.css('position', 'absolute')
                element.css('width', '100%')
                body.css('margin-bottom', '48px')
                element.css('bottom', '-48px')
              }
            } else {
              element.css('position', 'absolute')
              element.css('width', '100%')
              body.css('margin-bottom', '48px')
              element.css('bottom', '-48px')
            }
          }

          function onScroll() {
            setFooterPostion()
          }

          function onResize() {
            setFooterPostion()
          }

          setFooterPostion()
        }
      }
    })
})()
